<template lang="pug">
	.easy-creative--script-stream-visualizer.flex-1.full-width.bg-animated
		pre.pre-wrap(v-if="textMode") {{ displayTextPrepared }}
		ScriptTable(v-else, :script="script", :info="info", :preventEdit="true", itemClass="swing-in-top-fwd")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import ScriptTable from './EasyCreativeScriptTable.vue';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-script-stream-visualizer',
		props: ['info', 'runId', 'prepareScriptVAMFormat'],
		components: {
			Loader, ScriptTable
		},
		data() {
			return {
				currentPromptId: null,
				currentRunId: null,
				collectedInfo: [],
				loggedInfos: [],
				displayingInfo: [],
				script: []
			};
		},
		computed: {
			displayText() {
				return this.displayingInfo.join('');
			},
			displayTextPrepared() {
				return this.prepareDisplayText(this.displayText);
			},
			textMode() {
				return this.script.length === 0 && this.displayText.length > 5 && this.displayText.indexOf('{') === -1;
			}
		},
		watch: {
			'runId'() {
				this.init();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeScriptStreamVisualizer = this;
			
			this.$eventsBus.$on('signalr-on-notification', this.signalrOnNotification);

			this.init();
			
			this.info.addDebugFunc(this.debugFunc);

			this.$processScriptMode = _.debounce(this.processScriptMode, 200, {
				leading: false,
				traliling: true,
				maxWait: 500
			});

			this.$processTextMode = _.debounce(this.processTextMode, 400, {
				leading: false,
				traliling: true,
				maxWait: 1000
			});
		},
		destroyed() {
			this.$eventsBus.$off('signalr-on-notification', this.signalrOnNotification);
			this.info.removeDebugFunc(this.debugFunc);

			delete this.$processScriptMode;
			delete this.$processTextMode;
		},
		methods: {
			debugFunc() {
				return {
					promptStreams: [
						...this.loggedInfos.map(f => ({ chunks: f, result: f.join('') })),
						{
							chunks: [...this.displayingInfo, ...this.collectedInfo],
							result: [...this.displayingInfo, ...this.collectedInfo].join('')
						}
					]
				}
			},
			init() {
				this.currentRunId = this.runId;
				this.displayingInfo = [];
				this.collectedInfo = [];
				this.loggedInfos = [];
				this.script = [];
				this.initPrompt(null);
			},
			initPrompt(promptId) {
				this.currentPromptId = promptId;
				if (this.displayingInfo?.length || this.collectedInfo?.length) {
					this.loggedInfos.push([...this.displayingInfo, ...this.collectedInfo]);
				}
				this.collectedInfo = [];
				this.displayingInfo = [];
			},
			signalrOnNotification({ eventName, data }) {
				if (eventName === 'promptWritingStream' && data?.RunId === this.currentRunId) {
					if (data?.PromptId !== this.currentPromptId) {
						this.initPrompt(data?.PromptId);
					}
					
					if (data?.Delta) {
						this.collectedInfo.push(data?.Delta);
					}

					if (this.textMode) {
						this.$processTextMode();
					} else {
						this.$processScriptMode();
					}
				}
			},
			async processScriptMode() {
				let vamResult = await this.prepareScriptVAMFormat(this.collectedInfo.join(''), true) || [];

				let typesCounter = {};

				let getTypeId = (s) => {
					if (s?.type === 'text') {
						return `${s?.voice_gender}_${s?.voice_number}`;
					}

					return s?.type;
				}

				vamResult.map(f => {
					if (!f.id) {
						f.id = this.$Data.uuid();
					}
					f.generated = new Date();
					let curType = getTypeId(f);
					let currentTypeCounter = typesCounter[curType] || 0;

					f.typeId = `${curType}_${currentTypeCounter}`;
					
					if (!typesCounter[curType]) {
						typesCounter[curType] = 0;
					}
					typesCounter[curType] += 1;
				});

				if (!this.script?.length) {
					this.script = vamResult;
					return;
				}

				vamResult.map((f, i) => {
					let exists = this.script.find(s => s.typeId === f.typeId);
					if (!exists) {
						this.script.splice(i, 0, f);
					} else {
						_.assign(exists, _.omit(f, ['id']));
						delete f.__markToRemove;
					}
				});

				this.script.map((f) => {
					let exists = vamResult.find(s => s.typeId === f.typeId);
					if (!exists && !f.__markToRemove) {
						this.$set(f, '__markToRemove', new Date());
					}
				});
			},
			async processTextMode(force) {
				if (!force && this.$processing) return;

				this.$processing = true;

				if (this.collectedInfo.length > 0) {
					this.displayingInfo.push(this.collectedInfo[0]);
					this.collectedInfo.splice(0, 1);

					setTimeout(() => {
						if (this.collectedInfo.length > 0) {
							this.processTextMode(true);
						} else {
							this.$processing = false;
						}
					}, 60);
				}
			},
			prepareDisplayText(v) {
				return (v || '')
					.replace(/{(.*?):/g, '')
					.replace(/{(.*?)}/g, '')
					.replace(/[{}]/g, '')
					.replace(/\n /g, '\n');
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--script-stream-visualizer {
		pre {
			font-size: 16px;
			font-weight: 100;
			font-style: italic;
		}

		.swing-in-top-fwd {
			animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
		}
			
		@keyframes swing-in-top-fwd {
			0% {
				transform: rotateX(-100deg);
				transform-origin: top;
				opacity: 0;
			}
			100% {
				transform: rotateX(0deg);
				transform-origin: top;
				opacity: 1;
			}
		}

		@keyframes MOVE-BG {
			from {
				transform: translateX(0);
			}
			to { 
				transform: translateX(46px);
			}
		}
	}
</style>
